/**
 * 목록 출력 파일 내려받기
 */
export function safePrintFileName(name, ext) {
  const base = String(name || '목록출력')
    .replace(/[\\/:*?"<>|]+/g, '_')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 80) || '목록출력';
  const e = String(ext || '').replace(/^\./, '');
  return e ? `${base}.${e}` : base;
}

export function downloadBlob(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1500);
}
